import { Accessor, Component, For, Show, createSignal } from "solid-js";
import { cleanImagePath } from "./API";
import { Artwork } from "./Types";

type ArtworksBlocksProps = {
    artworks: Accessor<Artwork[]>;
    imageBackgroundColor?: string;
}
export const ArtworksBlocks : Component<ArtworksBlocksProps> =(props) => {
    const [showBlockTextForArtworkId, setShowBlockTextForArtworkId] = createSignal<number|null>(null);
    return (
        <div class="finalist-grid">
            <For each={props.artworks()}>{(artwork: Artwork) =>
                <div class="category-image" style={{ width: "200px", height: "200px", "display": "inline-block", "margin": "5px", "vertical-align": "top",
                "position": "relative", "background-color": artwork.backgroundColor || "#000" }}>
                    <a href={ "/Artwork/Index/" + artwork.id } target="_blank">
                        <img onMouseOver={(e: Event) => { e.stopPropagation(); setShowBlockTextForArtworkId(artwork.id); }}
                            style="width: 200px; height: 200px;" src={ cleanImagePath(artwork.primaryImageUrl) + "?mode=crop&format=jpg&width=300&height=300&anchor=topLeft" }
                            data-role="show-on-hover" data-sibling="gallery-image-overlay" />    
                        <Show when={showBlockTextForArtworkId() == artwork.id}>
                            <div class="gallery-image-overlay">
                                <p class="title">{artwork.title}</p>
                                <p class="salon">{artwork.medium} {artwork.dateRange}</p>
                            </div>
                        </Show>
                    </a>
                </div>
            }</For>
        </div>
    );
}